var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5278 7.67899L8.50919 0.209229H8.43314C4.72924 0.220042 1.72932 3.21996 1.71851 6.92386V6.99992L9.5278 7.67899Z",
    fill: "#ED6C47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58534 0.209229H8.50928V6.99992L11.9046 8.35805L15.3 6.99992V6.92386C15.2892 3.21996 12.2892 0.220042 8.58534 0.209229Z",
    fill: "#FF8F6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2999 7V7.0747C15.2893 10.7794 12.2886 13.7801 8.58389 13.7907H8.4345C4.72977 13.7801 1.72914 10.7794 1.71851 7.0747V7H15.2999Z",
    fill: "#D35230"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.84874 3.54689V10.7926C8.84705 11.0443 8.69447 11.2705 8.46167 11.3664C8.38754 11.3977 8.30788 11.4139 8.22739 11.4139H3.32112C3.22605 11.3052 3.13438 11.1898 3.04949 11.0744C2.18446 9.92041 1.71739 8.51684 1.71851 7.07465V6.92525C1.71653 5.62444 2.0967 4.35169 2.81181 3.26507C2.88651 3.14963 2.9646 3.03419 3.04949 2.92554H8.22739C8.56947 2.92813 8.84615 3.20481 8.84874 3.54689Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.50921 3.88649V11.1322C8.50919 11.2126 8.49303 11.2923 8.46167 11.3664C8.36581 11.5992 8.13963 11.7518 7.88786 11.7535H3.6301C3.52267 11.6444 3.41959 11.5312 3.32112 11.414C3.22605 11.3053 3.13438 11.1899 3.04949 11.0744C2.18446 9.92048 1.71739 8.51689 1.71851 7.07471V6.92532C1.71653 5.6245 2.0967 4.35175 2.81181 3.26514H7.88786C8.22995 3.26772 8.50662 3.5444 8.50921 3.88649Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.5092 3.88648V10.4531C8.50662 10.7952 8.22994 11.0718 7.88786 11.0744H3.04949C2.18446 9.92048 1.71739 8.51689 1.71851 7.07471V6.92532C1.71653 5.6245 2.0967 4.35175 2.81181 3.26514H7.88785C8.22994 3.26771 8.50662 3.54439 8.5092 3.88648Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.16967 3.88648V10.4531C8.16708 10.7952 7.89041 11.0718 7.54832 11.0744H3.04949C2.18446 9.92048 1.71739 8.51689 1.71851 7.07471V6.92532C1.71653 5.6245 2.0967 4.35175 2.81181 3.26514H7.54832C7.89041 3.26771 8.16708 3.54439 8.16967 3.88648Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32231 3.26514H7.54734C7.89106 3.26514 8.1697 3.54378 8.1697 3.8875V10.1125C8.1697 10.4562 7.89105 10.7349 7.54734 10.7349H1.32231C0.978598 10.7349 0.699951 10.4562 0.699951 10.1125V3.8875C0.699951 3.54378 0.978598 3.26514 1.32231 3.26514Z",
    fill: "url(#paint0_linear_36113_1209)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50282 4.92503C4.90805 4.89768 5.30979 5.01539 5.63619 5.25709C5.90842 5.50014 6.05389 5.85479 6.03072 6.21899C6.03517 6.47217 5.96771 6.72142 5.83617 6.93779C5.70301 7.15043 5.51115 7.32 5.28375 7.42604C5.02378 7.54695 4.73955 7.60665 4.4529 7.60056H3.66553V9.06395H2.85913V4.92503H4.50282ZM3.66485 6.96835H4.35886C4.57888 6.98451 4.79718 6.91939 4.9724 6.78534C5.11733 6.64632 5.19329 6.45027 5.17986 6.2499C5.17986 5.79379 4.91479 5.56573 4.38467 5.56573H3.66486V6.96835H3.66485Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36113_1209",
    x1: 1.9976,
    y1: 2.77883,
    x2: 6.87206,
    y2: 11.2212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA4C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C5401E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62F14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptIcon);
export default __webpack_public_path__ + "static/media/PptIcon.3bbede066b69d1ffd30dda4d62d223ab.svg";
export { ForwardRef as ReactComponent };